// @noflow

export type { Props as MultipleComboBoxProps, Item } from './MultipleComboBox'

export { MultipleComboBox } from './MultipleComboBox'
